import { pageConfig, flowTypes } from "@/common/service/page-config";
import { PBX_REGIONS, regions } from '@/plans/ZOOM_PHONE/helper/constants';

export const ZONE_BUNDLE_MODE = {
  GLOBAL_ONLY: 'global_only',
  ALL_REGIONS: 'all_regions',
  NO_GLOBAL: 'no_global'
};

export function getZOneBundleMode() {
  if (
    ![flowTypes.basic2pro, flowTypes.buyNow].includes(pageConfig.type) ||
    pageConfig?.marketingCoupon?.discountInfo
  ) {
    return {
      mode: ZONE_BUNDLE_MODE.ALL_REGIONS,
      filter: () => true
    };
  }
  if (pageConfig.from === 'zonebundle_zonebizpzsu') {
    return {
      mode: ZONE_BUNDLE_MODE.GLOBAL_ONLY,
      filter: x => x.key === PBX_REGIONS.GLOBAL
    };
  }

  return {
    mode: ZONE_BUNDLE_MODE.NO_GLOBAL,
    filter: x => x.key !== PBX_REGIONS.GLOBAL
  };
}

export const zoneBundleMode = getZOneBundleMode();

export const bundleRegions = (() => (
  pageConfig.enableOnlineBizPlusGlobalSelect ? 
  regions.concat({ key: PBX_REGIONS.GLOBAL, label: 'billing.pbx.global_select', desc: 'billing.pbx.calling_plans_Global_Select' }) : 
  regions
))();
